import React from 'react'
import { Handler } from 'shared/helpers/typeHelper'
import styled from 'styled-components'

import { LoadStop } from '../../../models/load'
import { MultistopPathTimeline } from './MultistopPathTimeline'

interface MultistopPathProps {
  id?: string
  deadhead?: number
  stops: Array<LoadStop>
  maskData?: boolean
  openMap?: Handler
  isSmall?: boolean
  isMedium?: boolean
  showAllStopsOnSmall?: boolean
  children?: React.ReactNode
  className?: string
}

export function MultistopPath({
  id,
  deadhead,
  stops,
  maskData,
  openMap,
  isSmall,
  isMedium,
  showAllStopsOnSmall,
  children,
  className,
}: MultistopPathProps) {
  return (
    <PathContainer id={id} className={className}>
      {children}
      <MultistopPathTimeline
        deadhead={deadhead}
        stops={stops}
        maskData={maskData}
        isSmall={isSmall}
        isMedium={isMedium}
        showAllStopsOnSmall={showAllStopsOnSmall}
        openMap={openMap}
      />
    </PathContainer>
  )
}

const PathContainer = styled.div`
  grid-area: stops;
`
